/*
 * This file is picked up by the build system only
 * when building for PRODUCTION
 */
import { register } from 'register-service-worker';
import { offerNewVersion } from 'boot/pwa-update';
register(process.env.SERVICE_WORKER_FILE, {
  ready: function ready() {
    console.log('App is being served from cache by a service worker.');
  },
  registered: function registered(registration) {
    // registration -> a ServiceWorkerRegistration instance
    console.log('Service worker has been registered.');
  },
  cached: function cached(registration) {
    // registration -> a ServiceWorkerRegistration instance
    console.log('Content has been cached for offline use.');
  },
  updatefound: function updatefound(registration) {
    // registration -> a ServiceWorkerRegistration instance
    console.log('New content is downloading.');
  },
  updated: function updated(registration) {
    // registration -> a ServiceWorkerRegistration instance
    // a new version is in: taken at the next start, or now when the user says so (#317, boot/pwa-update.js)
    console.log('New content is available.');
    offerNewVersion(registration);
  },
  offline: function offline() {
    console.log('No internet connection found. App is running in offline mode.');
  },
  error: function error(err) {
    console.error('Error during service worker registration:', err);
  }
}); // ServiceWorkerRegistration: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration